import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { NewRoofCostHeaderComponent } from '../new-roof-cost-header/new-roof-cost-header.component';
import { NewRoofCostBannerComponent } from '../new-roof-cost-banner/new-roof-cost-banner.component';
import { NewRoofCostTrustSignalsComponent } from '../new-roof-cost-trust-signals/new-roof-cost-trust-signals.component';
import { NewRoofCostHowItWorksComponent } from '../new-roof-cost-how-it-works/new-roof-cost-how-it-works.component';
import { NewRoofCostCalculatorComponent } from '../new-roof-cost-calculator/new-roof-cost-calculator.component';
import { NewRoofCostCertificationsComponent } from '../new-roof-cost-certifications/new-roof-cost-certifications.component';
import { NewRoofCostTestimonialsComponent } from '../new-roof-cost-testimonials/new-roof-cost-testimonials.component';
import { NewRoofCostPromoBannerComponent } from '../new-roof-cost-promo-banner/new-roof-cost-promo-banner.component';
import { NewRoofCostFooterComponent } from '../new-roof-cost-footer/new-roof-cost-footer.component';
import { LocationService } from '../../../../core/services/location.service';
import { QuestionnaireService } from '../../../../core/services/questionnaire.service';
import { StorageService } from '../../../../core/services/storage.service';
import { RoutePaths } from '../../../../core/constants/routes';

@Component({
  selector: 'app-new-roof-cost-page',
  standalone: true,
  imports: [
    CommonModule,
    NewRoofCostHeaderComponent,
    NewRoofCostBannerComponent,
    NewRoofCostTrustSignalsComponent,
    NewRoofCostHowItWorksComponent,
    NewRoofCostCalculatorComponent,
    NewRoofCostCertificationsComponent,
    NewRoofCostTestimonialsComponent,
    NewRoofCostPromoBannerComponent,
    NewRoofCostFooterComponent,
  ],
  templateUrl: './new-roof-cost-page.component.html',
  styleUrl: './new-roof-cost-page.component.scss',
})
export class NewRoofCostPageComponent implements OnInit, OnDestroy {
  fetchedZipcode = '';
  zipVal = '';
  isBrowser = false;
  private routerSub?: Subscription;

  constructor(
    private locationService: LocationService,
    private router: Router,
    private questionnaireService: QuestionnaireService,
    private storageService: StorageService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      this.fetchLocationZipcode();
      this.routerSub = this.router.events
        .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
        .subscribe((e) => {
          if (e.urlAfterRedirects?.includes(RoutePaths.GOOGLE_LANDING)) {
            this.fetchLocationZipcode();
          }
        });
    }
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();
  }

  fetchLocationZipcode(): void {
    this.locationService.fetchZipcode().subscribe({
      next: (res) => {
        this.fetchedZipcode = res.zipCode;
        if (res.zipCode) this.zipVal = res.zipCode;
      },
      error: (err) => console.error('Error fetching zipcode:', err),
    });
  }

  onStep1Click(): void {
    const zip = (this.zipVal || this.fetchedZipcode || '').trim();
    if (zip.length >= 5) {
      this.questionnaireService.updateQuestionaryStep({ zipCode: zip });
    }
    this.storageService.setItem('originLeads', 'true');
    const currentRoute = this.router.url.split('?')[0];
    const landingPath =
      currentRoute === '/' || currentRoute === ''
        ? RoutePaths.HOME
        : currentRoute.replace(/^\//, '');
    this.storageService.setItem('landing-page-path', landingPath);
    this.router.navigateByUrl(`/${RoutePaths.QUESTIONNAIRE}`);
  }
}
